<template>
  <el-table-column
    prop="to"
    label="Záró készlet"
    min-width="200"
  >
    <template slot-scope="scope">
            <span v-if="scope.row.to_count_per_pack === 1">
              {{ scope.row.to_count}} db
      </span>
      <span v-else>
              {{ scope.row.to_count}} {{ scope.row.to_pack_type_name}}
      </span>
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'supplier.name',
  };
</script>
